import { Component, Input } from '@angular/core';

@Component({
  selector: 'am-banner',
  template: `
    <div
      data-testid="banner"
      role="banner"
      class="banner py-2 px-3 rounded"
      [attr.color]="color"
      [ngClass]="className"
      [class.shadow-xs]="raised"
    >
      <div class="content mat-body" role="note" [ngClass]="contentClassName">
        <div class="icon-slot" data-testid="icon-wrapper">
          <ng-content select="am-icon"></ng-content>
          <ng-content select="mat-icon"></ng-content>
        </div>
        <ng-content select="[slot='content']"></ng-content>
        <ng-content></ng-content>
      </div>
      <div class="actions" data-testid="actions-wrapper">
        <ng-content select="[slot='actions']"></ng-content>
      </div>
    </div>
  `,
  styleUrls: ['./banner.component.scss'],
})
export class BannerComponent {
  /** CSS class(es) to be applied to the banner element */
  @Input() className: string;
  @Input() contentClassName: string;
  /** Applies a color scheme to the banner */
  @Input() color: 'primary' | 'accent' | 'success' | 'caution' | 'warn';
  /** Adds a dropshadow and removes the border */
  @Input() raised = false;
}
